<template>
  <div>
    <h3 class="mt-3 mb-base">Live Scrip FIFO Report</h3>
    <div>
      <!-- filters  -->
      <vs-row>
        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
          <SelectForeign :model.sync="filters.portfolio" label="Select by Portfolio" placeholder="Type to Search"
            :multiple="false" :load_initial="true" :label_keys="['name',]" label_class="mb-0" input_class="mt-0 bg-white"
            :show_id_in_label="false" :endpoint="$store.state.apiendpoints.portfolio_list" :use_id_as_value="true"
            :disabled="loading" list_length="10000" />
          <small class="block text-danger mt-1" v-if="api_errors && api_errors.portfolio">
            {{ api_errors.portfolio.join(', ') }}
          </small>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
          <SelectForeign :model.sync="filters.scrip" label="Select by Scrip" placeholder="Type to Search"
            :multiple="false" :load_initial="true" :label_keys="['scrip_name',]" label_class="mb-0"
            input_class="mt-0 bg-white" :show_id_in_label="false" :endpoint="$store.state.apiendpoints.share_list"
            :use_id_as_value="true" :disabled="loading" list_length="10000" />
          <small class="block text-danger mt-1" v-if="api_errors && api_errors.scrip">
            {{ api_errors.scrip.join(', ') }}
          </small>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1 mb-3">
          <SelectDate :disabled="loading" :selectedDate.sync="filters.trade_date" label="Select by Date" />
          <small class="block text-danger mt-1" v-if="api_errors && api_errors.trade_date">
            {{ api_errors.trade_date.join(', ') }}
          </small>
        </vs-col>
      </vs-row>

      <!-- table  -->
      <vs-table :data="results" class="freeze_row row2">
        <vs-tr>
          <vs-th>Contract Id</vs-th>
          <vs-th>Trade Date</vs-th>
          <vs-th>Contract Type</vs-th>
          <vs-th>Market Rate</vs-th>
          <vs-th>Qty</vs-th>
          <vs-th>Remaning Qty</vs-th>
          <vs-th>Setoff Contract</vs-th>
          <vs-th>P&L</vs-th>
        </vs-tr>
        <vs-tr v-for="(item, index) in results" :key="index">
          <vs-td>{{ item.id }}</vs-td>
          <vs-td>
            <template v-if="item.date">
              <FormatText :text="item.date" format="date" />
            </template>
            <template v-else>
              -
            </template>
          </vs-td>
          <vs-td>
            <FormatText :text="item.type" format="select" :kwargs="contract_type_options" />
          </vs-td>
          <vs-td>{{ item.amount }}</vs-td>
          <vs-td>{{ item.qty }}</vs-td>
          <vs-td>{{ item.left == null ? '-' : item.left }}</vs-td>
          <vs-td>{{ item.setoff_id ? item.setoff_id : '-' }}</vs-td>
          <vs-td>{{ item.profit_loss ? item.profit_loss : '-' }}</vs-td>
        </vs-tr>
      </vs-table>
    </div>
  </div>
</template>
  
<script>
import { Request } from "../../utils/requests";
import SelectDate from "../../components/letstream/ls-select-date/SelectDate.vue"

export default {
  components: {
    SelectDate
  },
  props: {
    embedded_mode: {
      default: false,
    },
    embedded_filters: {
      default: null,
    },
  },
  data() {

    return {
      results: [],
      loading: false,

      filters: {
        portfolio: null,
        scrip: null,
        trade_date: null
      },

      contract_type_options: [
        { value: "fp", label: "Fresh Purchase" },
        { value: "ip", label: "IPO" },
        { value: "ri", label: "Right Issue" },
        { value: "ns", label: "Normal Sale" },
        { value: "bb", label: "Buy Back" },
        { value: "bonus", label: "Bonus Purchase" },
        { value: "split", label: "Split Purchase" },
        { value: "merge", label: "Merge Purchase" },
        { value: "demerge", label: "Demerge Purchase" },
      ],

      api_errors: {},
    };
  },
  mounted() {
    this.timer = null;
    this.init();
  },
  watch: {
    filters: {
      deep: true,
      handler(newV) {

        if (this.timer) clearTimeout(this.timer);

        this.timer = setTimeout(() => {
          this.$router.push({ name: this.$route.name, query: newV });
        }, 800);
      },
    },
    "$route.query"(newV) {
      this.load_data(newV);
    },
  },
  methods: {
    init() {
      this.load_data(this.filters);
    },
    checking_for_filters(filters) {
      if (!filters.portfolio) {
        this.api_errors = {
          "portfolio": [
            "Portfolio is required.",
          ]
        }
        return true
      }

      if (!filters.scrip) {
        this.api_errors = {
          "scrip": [
            "Scrip is required.",
          ]
        }
        return true

      }

      if (!filters.trade_date) {
        this.api_errors = {
          "trade_date": [
            "Date is required.",
          ]
        }
        return true
      }

      return false
    },
    load_data(filters = null) {

      // checking for filters
      if (this.checking_for_filters(filters)) return

      let url = this.$store.state.apiendpoints.live_fifo_table_new;

      let payload = null;
      if (filters) payload = this.deepclone(filters);
      else payload = {};

      this.loading = true;
      this.$vs.loading();

      Request(this, "GET", url, payload).then(
        (res) => {
          this.api_errors = {}
          this.results = res;
          this.loading = false;
          this.$vs.loading.close();
        },
        (err) => {
          this.$vs.notify({
            time: 2500,
            title: "Unknown Error",
            text: "An Error Occured. Please Try Again",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
          this.api_errors = {}
          this.loading = false;
          this.$vs.loading.close();
        }
      );
    },
  },
};
</script>